import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../../../../../../../components/global/Button';
import Angle from '../../../../../../../../../../../components/global/Angle';

const propTypes = {
  onDelete: PropTypes.func,
  onMoveLeft: PropTypes.func,
  onMoveRight: PropTypes.func,
};

const SlideshowThumbnailControls = ({ onDelete, onMoveLeft, onMoveRight }) => {
  return (
    <div className="slideshow-designer-thumbnail-controls">
      {onDelete && (
        <Button
          btnStyle="reset"
          onClick={onDelete}
          className="slideshow-designer-thumbnail-control-btn delete-btn"
        >
          &times;
        </Button>
      )}
      {onMoveLeft && (
        <Button
          btnStyle="reset"
          onClick={onMoveLeft}
          className="slideshow-designer-thumbnail-control-btn left-btn"
        >
          <Angle direction="left" />
        </Button>
      )}
      {onMoveRight && (
        <Button
          btnStyle="reset"
          onClick={onMoveRight}
          className="slideshow-designer-thumbnail-control-btn right-btn"
        >
          <Angle direction="right" />
        </Button>
      )}
    </div>
  );
};

SlideshowThumbnailControls.propTypes = propTypes;

export default SlideshowThumbnailControls;
